<template>
  <div class="w-full" data-testid="session-secured-popup">
    <!-- Title Section -->
    <div class="mb-5 self-stretch flex flex-col justify-start items-center gap-2">
      <div class="self-stretch text-center text-white text-2xl font-bold font-['Inter'] leading-[30px]">
        {{ $t('enter_password') }}
      </div>
      <div class="self-stretch text-center text-white/90 text-base leading-[1.18rem]">
        {{ $t('secure_session_pwd_required_title') }}
      </div>
    </div>

    <form action="#" method="POST" @submit.prevent="secureHandle" novalidate>
      <div class="mb-6 max-[800px]:mb-[18px]">
        <label class="block text-white/90 text-base leading-[1.18rem] mb-[13px] pl-[10px]" for="session_password">{{ $t('profile_password') }}</label>
        <div class="relative">
          <input
            :type="showPassword ? 'text' : 'password'"
            required
            name="session_password"
            id="session_password"
            ref="password_input"
            v-model="sessionPassword"
            autocomplete="off"
            placeholder=""
            class="w-full h-[44px] hover:bg-[#2A323B] bg-[#22282F] rounded-[10px] px-3 pr-11 placeholder-white/70 outline-none caret-white border-2 border-transparent focus:border-[#6CBFFF] text-white"
            data-testid="session-password-input"
          />
          <button
            type="button"
            tabindex="-1"
            @mousedown.prevent
            @click="showPassword = !showPassword"
            class="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
          >
            <img
              :src="showPassword ? EyeIcon : EyeOffIcon"
              class="w-5 h-5 opacity-70 hover:opacity-100"
              alt="Toggle visibility"
            />
          </button>
        </div>
      </div>

      <div class="self-stretch flex flex-col justify-start items-stretch gap-3">
        <button
          type="submit"
          name="session_password_submit"
          id="session_password_submit"
          class="w-full h-[40px] px-[30px] bg-[#6CBFFF] hover:bg-opacity-30 rounded-xl shadow-[0px_5.01333px_5.01333px_rgba(0,0,0,0.25)] inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer"
          data-testid="session-password-submit"
        >
          <div class="text-black text-base font-medium font-['Inter'] leading-normal">
            {{ $t('common_join') }}
          </div>
        </button>
        <button
          type="button"
          class="w-full h-[40px] px-[30px] bg-[#22282F] hover:bg-[#2A323B] rounded-xl inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer"
          @click="$emit('leave')"
          data-testid="session-password-leave"
        >
          <div class="text-white text-base font-medium font-['Inter'] leading-normal">
            {{ $t('session_leave') }}
          </div>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import EyeIcon from '@/assets/icons/eye.svg';
import EyeOffIcon from '@/assets/icons/eye-off.svg';

export default {
  name: 'SessionSecured',
  emits: ['provided', 'leave'],
  data() {
    return {
      sessionPassword: "",
      showPassword: false,
      EyeIcon,
      EyeOffIcon,
    }
  },
  methods: {
    secureHandle() {
      if (this.sessionPassword) {
        this.$store.commit("nonpersist/setSessionPassword", this.sessionPassword);
        this.$emit("provided", this.sessionPassword);
      } else {
        this.$toast.error('secure_session_pwd_required_empty_error');
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.password_input?.focus());
  }
}
</script>
